module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/stack_add_graphic_portrait@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/stack_add_graphic_portrait@2x.png
// module id = 717
// module chunks = 0